module.exports = __webpack_public_path__ + "static/media/YM03_0.3d64b853.jpg";